<template>
  <div>
    <p>Dakland - Trang chủ</p>
  </div>
</template>

<script>
import {mapActions} from 'vuex'

export default {
  name: 'Dashboard',
  async mounted() {
    await Promise.all([
      this.getUserList(),
      this.getLocationAndZoneTypeList()
    ])
  },
  methods: {
    ...mapActions('auth', ['getUserList']),
    ...mapActions('common', ['getLocationAndZoneTypeList'])
  }
}
</script>
